import { Injectable} from '@angular/core';
import { Http, Request, RequestOptionsArgs, Response, RequestOptions, ConnectionBackend, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { PubSubService} from './pubsubservice';
import 'rxjs/Rx';
import { StorageUtils} from '../storage.utils';
import {EnvUtils} from '../env.utils';

@Injectable()
export class CustomHttp extends Http {
    constructor(backend: ConnectionBackend
                , defaultOptions: RequestOptions
                , private _pubsub: PubSubService) {
        super(backend, defaultOptions);
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.request(url, options));
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        if (url.indexOf('validate_token') > 0 ) {
            return this.intercept(super.get(url, null));
        }
        if (options == null) {
            if(url.includes('clientId')) {
                options = new RequestOptions();
            } else {
                options = new RequestOptions({withCredentials: true });
            }

        }
        if (options.headers == null) {
            options.headers = new Headers();
            options.headers.append('Content-Type', 'application/json');
        }

        const access_token = EnvUtils.envCdToAccessToken();

        if (access_token) {
            options.headers.set('Authorization', 'Bearer ' + access_token);
        }

        const teamDataStr = StorageUtils.getItem('alertNow.team');
        const teamData = JSON.parse(teamDataStr);
        if (teamData !== null) {
            if (url.indexOf('/oauth/wechat') === -1 && url.indexOf('/oauth') === -1 ) {
                options.headers.append('teamType', teamData.type);
                if (teamData.teamNoUseYn === 'Y') {
                    options.headers.append('teamNo', teamData.no);
                }
            }
        }

        const timeStamp = +new Date();
        if (!url.includes('clientId')) {
            if (url.includes('?')) {
                url = url + '&_=' + timeStamp;
            }else {
                url = url + '?_=' + timeStamp;
            }
        }

        const locale = $.cookie('BSP_LangCode') || 'en';
        if (url.includes('?')) {
            url = url + '&BSP_LangCode=' + locale;
        } else {
            url = url + '?BSP_LangCode=' + locale;
        }

        return this.intercept(super.get(url, options));
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.post(url, body, this.getRequestOptionArgs(options)));
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.put(url, body, this.getRequestOptionArgs(options)));
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        if (options == null) {
            options = new RequestOptions({withCredentials: true });
        }
        if (options.headers == null) {
            options.headers = new Headers();
            options.headers.append('Content-Type', 'application/json');
        }

        const access_token = EnvUtils.envCdToAccessToken();
        if (access_token) {
            options.headers.append('Authorization', 'Bearer ' + access_token);
        }

        const teamDataStr = StorageUtils.getItem('alertNow.team');
        const teamData = JSON.parse(teamDataStr);
        if (teamData !== null) {

            if (url.indexOf('/oauth/wechat') === -1) {
                options.headers.append('teamType', teamData.type);
                if (teamData.teamNoUseYn === 'Y') {
                    options.headers.append('teamNo', teamData.no);
                }
            }

            //options.headers.append('teamNo', teamData.no);
        }
        return this.intercept(super.delete(url, options));
    }

    getRequestOptionArgs(options?: RequestOptionsArgs): RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions({withCredentials: true });
        }
        if (options.headers == null) {
            options.headers = new Headers();
            options.headers.append('Content-Type', 'application/json');
        }

        const access_token = EnvUtils.envCdToAccessToken();

        if (access_token) {
            options.headers.append('Authorization', 'Bearer ' + access_token);
        }

        const teamDataStr = StorageUtils.getItem('alertNow.team');
        const teamData = JSON.parse(teamDataStr);
        if (teamData !== null) {
            options.headers.append('teamType', teamData.type);
            if (teamData.teamNoUseYn === 'Y') {
                options.headers.append('teamNo', teamData.no);
            }
        }
        return options;
    }

    // 메시지 팝업 이벤트용 인터셉터
    intercept(observable: Observable<Response>): Observable<Response> {
        this._pubsub.beforeRequest.emit({status : 'ok', body: 'beforeRequestEvent'});
        return observable.do(
            null,
            (error) => {
                this._pubsub.afterRequest.emit({status : 'error', body: error});
            },
            () => this._pubsub.afterRequest.emit({status : 'ok', body: 'afterRequestEvent'})
        );
    }

    /* IE Version Number 반환 */
    detectIE() {
        const ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // IE 12 / Spartan
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge (IE 12+)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        const msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        const trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            const rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        const edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
    }

    /* searchWord 인코딩 */
    searchUrlEncord(url: string, params: Array<string>): string {
        params.forEach((param: string) => {
            if (url.indexOf(param) > 0) {
                // console.log('>>>> get url1 : ' + url);
                const u1 = url.split(param)[0];
                const u2 = url.split(param)[1];
                let searchWord = '';
                let others = '';
                if (u2.indexOf('&') > 0) {
                    searchWord = u2.split('&')[0];
                    others = u2.replace(searchWord, '');
                    url = u1 + param + encodeURIComponent(searchWord) + others;
                } else {
                    url = u1 + param + encodeURIComponent(u2);
                }
                // console.log('>>>> get url : ' + url);
            }
        });
        return url;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/utils/src/customHttp/http-interceptor.ts